import { makeStyles, tokens } from "@fluentui/react-components";

export const useChatInputTextStyles = makeStyles({
  textAreaContainer: { width: "100%", position: "relative", marginBottom: tokens.spacingVerticalL },
  textArea: {
    width: "100%",
    height: "170px",
    "& textarea": {
      // 37px is the height of the dropdown container
      maxHeight: "calc(170px - 37px)",
    },
  },
  dropdownContainer: {
    display: "flex",
    width: "100%",
    position: "absolute",
    bottom: 0,
    borderTop: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke1}`,
    justifyContent: "space-between",
    paddingTop: tokens.strokeWidthThick,
    paddingBottom: tokens.strokeWidthThick,
  },
  dropdown: {
    borderRight: "none",
    borderTop: "none",
    borderBottom: "none",
    borderRadius: 0,
  },
  sendBtn: {
    marginRight: tokens.strokeWidthThickest,
    marginLeft: "auto",
  },
});
